export var environment = {
    production: false,
    sessionCookieDomain: '.kibook.dev',
    apiUrl: 'https://api.kibook.dev',
    gmapKey: 'AIzaSyBVReNP7mdaNA022B8urBVeH6ayaVnB4w0',
    customerShortname: '',
    commitHash: 'CI_COMMIT_SHA',
    forwardsCompatibilityMode: true,
    allowPreviewSwitch: true
};
//# sourceMappingURL=environment.js.map